'use client';
var classes = {"card":"m_26775b0a"};

export { classes as default };
//# sourceMappingURL=CheckboxCard.module.css.mjs.map
